import posthog from "posthog-js";

let didInit = false;
let didWarnInvalidKey = false;

function getProjectApiKey(): string | undefined {
  const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim();
  if (!apiKey) return undefined;
  if (!apiKey.startsWith("phc_")) {
    if (process.env.NODE_ENV === "development" && !didWarnInvalidKey) {
      didWarnInvalidKey = true;
      console.warn(
        "[analytics] NEXT_PUBLIC_POSTHOG_KEY must be the Project API Key (phc_...). Personal keys (phx_...) cannot ingest web events."
      );
    }
    return undefined;
  }
  return apiKey;
}

export function isPostHogConfigured(): boolean {
  return Boolean(getProjectApiKey());
}

export function initPostHog(): void {
  if (didInit || typeof window === "undefined") return;
  const apiKey = getProjectApiKey();
  if (!apiKey) return;

  didInit = true;
  posthog.init(apiKey, {
    api_host:
      process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    person_profiles: "identified_only",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
  });
}

export function getPostHogClient() {
  if (typeof window === "undefined") return null;
  if (!isPostHogConfigured()) return null;
  initPostHog();
  return posthog;
}
